class OverlayTeaserContent {
  /**
   * @param {HTMLElement} element - OverlayTeaser element
   */
  constructor(element) {
    this.element = element;

    this.config = {
      selectors: {
        openButton: ".js-OverlayTeaser-openButton",
        closeButton: ".js-OverlayTeaser-closeButton",
        openedContainer: ".js-OverlayTeaser-opened",
        closedContainer: ".js-OverlayTeaser-closed",
      },
      classes: {
        showAnimation: "OverlayTeaser-content--animationShow",
        hideAnimation: "OverlayTeaser-content--animationHide",
        hidden: "is-hidden",
        oneClick: "OverlayTeaser-content--oneClick",
      },
    };

    this.openButton = this.element.querySelector(
      this.config.selectors.openButton
    );

    this.closeButton = this.element.querySelector(
      this.config.selectors.closeButton
    );

    this.openedContainer = this.element.querySelector(
      this.config.selectors.openedContainer
    );

    this.closedContainer = this.element.querySelector(
      this.config.selectors.closedContainer
    );

    this.oneClick = this.element.classList.contains(
      this.config.classes.oneClick
    );

    this.animatedContainer = this.oneClick
      ? this.closedContainer
      : this.openedContainer;

    this._handleOpenButton = this._handleOpenButton.bind(this);
    this._handleCloseButton = this._handleCloseButton.bind(this);
    this._handleOpenAnimationEnd = this._handleOpenAnimationEnd.bind(this);
    this._handleCloseAnimationEnd = this._handleCloseAnimationEnd.bind(this);

    this._bind();
  }

  /**
   * binds event listener
   *
   * @private
   */
  _bind() {
    this.openButton?.addEventListener("click", this._handleOpenButton);
    this.closeButton?.addEventListener("click", this._handleCloseButton);
  }

  /**
   * handles click on open button and
   * triggers the animation to show the open state
   *
   * @private
   */
  _handleOpenButton() {
    this.openedContainer.addEventListener(
      "animationend",
      this._handleOpenAnimationEnd,
      { once: true }
    );

    this.openButton.setAttribute("aria-expanded", "true");
    this.openedContainer.classList.remove(this.config.classes.hidden);
    this.element.classList.add(this.config.classes.showAnimation);
  }

  /**
   * handles end of open animation
   * focus close button and hide the closed state
   *
   * @private
   */
  _handleOpenAnimationEnd() {
    this.closeButton.focus();
    this.closedContainer.classList.add(this.config.classes.hidden);
  }

  /**
   * handles click on close button and
   * triggers the animation to hide the opened state
   *
   * @private
   */
  _handleCloseButton() {
    this.animatedContainer.addEventListener(
      "animationend",
      this._handleCloseAnimationEnd,
      { once: true }
    );

    if (!this.oneClick) {
      this.openButton.setAttribute("aria-expanded", "false");
    }
    this.element.classList.add(this.config.classes.hideAnimation);
  }

  /**
   * handles end of close animation
   * hides open state
   *
   * @private
   */
  _handleCloseAnimationEnd() {
    this.animatedContainer.classList.add(this.config.classes.hidden);
  }
}

export default OverlayTeaserContent;
